<template>
  <div class="create_class-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim = true" class="nav-wrap">
        <p class="title">创建五人制培训班</p>
        <div class="nav-right" slot="right">
          <p>开班成功后，系统将自动创建学员帐号，并分组~</p>
        </div>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form :model="formData" :rules="formRules" ref="mainForm" label-width="160px" size="medium" class="form-cont">
              <el-form-item label="关联已批准开班申请">
                <el-select v-model="formData.application_id" @change="handleApplicationChange(formData.application_id)" class="input-w260" clearable placeholder="请选择已批准开班申请">
                  <el-option label="无" value=""></el-option>
                  <el-option v-for="(item, index) in select_application_list" :key="index" :label="item.name" :value="item.application_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主办机构" class="inline-item-wrap" required>
                <el-form-item v-for="(item, index) in formData.hostOrg" label-width="0px" :prop="'hostOrg.' + index + '.val'" :rules="{
                    required: true,
                    message: `此项不能为空`,
                    trigger: `blur`,
                  }" class="form-input-item" :key="item.key">
                  <el-input :placeholder="item.placeholder" v-model.trim="item.val" class="input-w260"></el-input>
                  <i v-if="index > 0" class="input-icon el-icon-close" @click="removeHost(item, 'hostOrg')"></i>
                </el-form-item>
                <!-- 五人制当前木人主办机构中国足协，承办机构当地足协 -->
                <el-button v-if="false" type="primary" size="medium" icon="el-icon-plus" @click="
                    addHost('hostOrg', {
                      val: '',
                      key: Date.now(),
                      placeholder: '请填写主办机构',
                    })
                  " :disabled="formData.hostOrg.length > 1" class="form-item-btn">更多
                </el-button>
              </el-form-item>
              <el-form-item label="承办机构" class="inline-item-wrap">
                <el-form-item v-for="(item, index) in formData.underOrg" label-width="0px" :prop="'underOrg.' + index + '.val'" class="form-input-item" :key="item.key">
                  <el-input :placeholder="item.placeholder" v-model.trim="item.val" class="input-w260"></el-input>
                  <i v-if="index > 0" class="input-icon el-icon-close" @click="removeHost(item, 'underOrg')"></i>
                </el-form-item>
                <!-- 五人制当前木人主办机构中国足协，承办机构当地足协 -->
                <el-button v-if="false" type="primary" size="medium" icon="el-icon-plus" @click="
                    addHost('underOrg', {
                      val: '',
                      key: Date.now(),
                      placeholder: '请填写承办机构',
                    })
                  " :disabled="formData.underOrg.length > 1" class="form-item-btn">更多
                </el-button>
              </el-form-item>
              <el-form-item label="协办机构" class="inline-item-wrap">
                <el-form-item v-for="(item, index) in formData.assistOrg" label-width="0px" :prop="'assistOrg.' + index + '.val'" class="form-input-item" :key="item.key">
                  <el-input :placeholder="item.placeholder" v-model.trim="item.val" class="input-w260"></el-input>
                  <i v-if="index > 0" class="input-icon el-icon-close" @click="removeHost(item, 'assistOrg')"></i>
                </el-form-item>
                <el-button type="primary" size="medium" icon="el-icon-plus" @click="
                    addHost('assistOrg', {
                      val: '',
                      key: Date.now(),
                      placeholder: '请填写协办机构',
                    })
                  " :disabled="formData.assistOrg.length > 1" class="form-item-btn">更多
                </el-button>
              </el-form-item>
              <el-form-item label="培训班级别" prop="className" class>
                <el-select v-model="formData.class_level" disabled @change="selectLevel" class="input-w260" placeholder="请选择培训班级别">
                  <!-- levelOptions classTrainLevelList -->
                  <el-option v-for="item in classTrainLevelList" :key="item.value" :label="item.key" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="培训班名称" prop="className" class>
                <el-input disabled v-model.trim="formData.className" class="input-w260" placeholder="请填写培训班名称"></el-input>
              </el-form-item>
              <el-form-item label="开班地区" required class="inline-item-wrap">
                <el-form-item label-width="0px" prop="classAddress.province" :rules="{
                    required: true,
                    validator: validateProvince,
                    trigger: `change`,
                  }" class="form-input-item">
                  <el-select v-model="formData.classAddress.province" class="hide"></el-select>
                  <select class="set-sel input-w200" @change="provinceChange" v-model="formData.classAddress.province" :style="{
                      border:
                        provinceSelErr === true
                          ? selTestErrorBorder
                          : provinceSelErr === false
                          ? selTestRightBorder
                          : '',
                    }">
                    <option value>请选择省份</option>
                    <option v-for="province in provinceList" :key="province.id" :value="province.id">
                      {{ province.text }}
                    </option>
                  </select>
                </el-form-item>
                <el-form-item label-width="0px" prop="classAddress.city" :rules="{
                    required: true,
                    validator: validateCity,
                    trigger: `change`,
                  }" class="form-input-item">
                  <el-select v-model="formData.classAddress.city" class="hide"></el-select>
                  <select class="set-sel input-w200" @change="cityChange" v-model="formData.classAddress.city" :style="{
                      border:
                        citySelErr === true
                          ? selTestErrorBorder
                          : citySelErr === false
                          ? selTestRightBorder
                          : '',
                    }">
                    <option value>请选择市</option>
                    <option v-for="item in cityList" :key="item.id" :value="item.id">
                      {{ item.text }}
                    </option>
                  </select>
                </el-form-item>
                <!-- 还好没把县级下拉框删了，不出所料，果然后来又被加上了🙂 -->
                <el-form-item label-width="0px" prop="classAddress.county" :rules="{
                    required: isCountyNeeded,
                    validator: validateCounty,
                    trigger: `change`,
                  }" class="form-input-item">
                  <el-select v-model="formData.classAddress.county" class="hide"></el-select>
                  <select class="set-sel input-w200" v-model="formData.classAddress.county" :style="{
                      border:
                        countySelErr === true
                          ? selTestErrorBorder
                          : countySelErr === false
                          ? selTestRightBorder
                          : '',
                    }">
                    <option value>请选择县区</option>
                    <option v-for="item in countyList" :key="item.id" :value="item.id">
                      {{ item.text }}
                    </option>
                  </select>
                </el-form-item>
              </el-form-item>
              <el-form-item label="培训日期" required>
                <el-form-item prop="trainStart" class="date-form-item">
                  <el-date-picker type="date" :editable="false" :clearable="false" @change="changeState" :picker-options="trainStartOpt" :default-value="calendarShow" value-format="timestamp" placeholder="请选择开始时间" v-model="formData.trainStart" style="width: 100%"></el-date-picker>
                </el-form-item>
                <span class="date-form-text">————</span>
                <el-form-item prop="trainEnd" class="date-form-item">
                  <el-date-picker type="date" :editable="false" :clearable="false" value-format="timestamp" :picker-options="trainEndOpt" :default-value="calendarShow" placeholder="请选择结束时间" v-model="formData.trainEnd" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-form-item>
              <el-form-item class="traindate-tip">
                <div class="text">注：培训日期结束，学员帐号将自动关闭~</div>
              </el-form-item>
              <el-form-item label="期数" prop="period" class>
                <span class="text_di">第</span>
                <el-input-number v-model="formData.period" controls-position="right" :min="1"></el-input-number>
                <span class="text_qi">期</span>
                <span style="color:#ff0000;margin-left:20px;font-size:15px" v-if="formData.class_level === 'L1'"> * 培训班期数需询问中国足协</span>
              </el-form-item>
              <el-form-item label="主讲师" prop="lecturer">
                <!--<el-select v-model="formData.lecturer" class="hide"></el-select>
                <select
                  class="set-sel input-w200"
                  v-model="formData.lecturer"
                  :style="{border: lectureSelErr === true ? selTestErrorBorder: (lectureSelErr === false ? selTestRightBorder : '')}"
                >
                  <option value="">足协指派</option>
                  <option
                    v-for="(lecturer) in lecturerList"
                    :key="lecturer.user_id"
                    :value="lecturer.user_id"
                  >{{lecturer.name}}({{lecturer.mobile_phone}})</option>
                </select>-->
                <el-select v-model="formData.lecturer" :default-first-option="true" :filter-method="lecturerFilter" @blur="lecturerBlur" filterable>
                  <el-option label="足协指派" value=""></el-option>
                  <el-option v-for="lecturer in lecturerList" :key="lecturer.user_id" :label="`${lecturer.teacher_name_unit}`" :value="lecturer.user_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="助理讲师" class="inline-item-wrap form-item-nomb">
                <el-form-item v-for="(item, index) in formData.assistantLecturer" label-width="0px" :prop="'assistantLecturer.' + index + '.val'" :rules="{
                    validator: (rule, val, callback) => {
                      return validateAssLec(rule, val, callback, index);
                    },
                    trigger: `change`,
                  }" class="form-input-item input-item-hasmb" :key="item.key">
                  <el-select v-model="item.val" :default-first-option="true" :filter-method="assistantFilter" @focus="assistantIdx = index" @blur="assistantBlur" clearable filterable>
                    <el-option :label="item.placeholder" value=""></el-option>
                    <el-option v-for="lecturer in assistantLecturerList" :key="lecturer.user_id" :label="`${lecturer.teacher_name_unit}`" :value="lecturer.user_id"></el-option>
                  </el-select>
                  <i v-if="index > 0" class="input-icon el-icon-close" @click="removeHost(item, 'assistantLecturer')"></i>
                </el-form-item>
                <el-button type="primary" size="medium" icon="el-icon-plus" @click="
                    addHost(
                      'assistantLecturer',
                      {
                        val: '',
                        key: Date.now(),
                        placeholder: '(空)',
                        isTestErr: null,
                        errMsg: '',
                      },
                      assistantLecturerList.length - 1
                    )
                  " :disabled="
                    formData.assistantLecturer.length >
                    assistantLecturerList.length - 1
                  " class="form-item-btn button-hasmb">更多
                </el-button>
              </el-form-item>
              <el-form-item label="实习讲师" class="inline-item-wrap form-item-nomb">
                <el-form-item v-for="(item, index) in formData.fieldworkLecturer" label-width="0px" :prop="'fieldworkLecturer.' + index + '.val'" class="form-input-item" :key="item.key">
                  <el-input :placeholder="item.placeholder" v-model="item.val" class="input-w200 input-item-hasmb"></el-input>
                  <i v-if="index > 0" class="input-icon el-icon-close" @click="removeHost(item, 'fieldworkLecturer')"></i>
                </el-form-item>
                <el-button type="primary" size="medium" icon="el-icon-plus" @click="
                    addHost(
                      'fieldworkLecturer',
                      { val: '', key: Date.now(), placeholder: '实习讲师' },
                      5
                    )
                  " :disabled="formData.fieldworkLecturer.length > 5" class="form-item-btn button-hasmb">更多
                </el-button>
              </el-form-item>
              <el-form-item label="学员名单" prop="saveStus" required class="test-inline">
                <el-button type="primary" @click="showExcelDialog">批量录入
                </el-button>
                <el-button type="primary" @click="showStusDialog">录入名单
                </el-button>
                <span :class="['tip', testStus ? 'yes' : 'no']">{{
                  testStus ? "学员添加成功" : "学员未添加"
                }}</span>
              </el-form-item>
              <!-- <el-form-item v-if="formData.class_level === 'C'"
                            label="快速培训通道"
                            class="test-inline">
                <el-radio-group v-model="formData.is_special_train">
                  <el-radio :label="0" border>否</el-radio>
                  <el-radio :label="1" border>是</el-radio>
                </el-radio-group>
                <p class="no">注：C级学员快速培训通道，允许特批的“整班学员”在D级不够12个月参加C的培训(为职业足球运动员保留)</p>
              </el-form-item> -->
              <el-form-item label="培训课表" prop="curriculum" class="up-form-item">
                <!-- <el-input v-model="formData.curriculum" class="upfile-input"> -->
                <!-- slot="append" -->
                <div class="upfile-wrap">
                  <!-- :default-img="$options._myOpt.class_d" -->
                  <image-up :lt-size="{ msg: '上传图片大小不能超过10MB!', reg: 10 }" :lt-format="{
                      msg: '仅支持jpg,jpeg,png,gif格式的图片',
                      reg: /^.*\.(jpg|png|jpeg|gif)$/i,
                    }" :imgval.sync="formData.curriculum" :cover="
                      formData.class_level === 'L1'
                        ? $options._myOpt.class_L1
                        : formData.class_level === 'D'
                        ? $options._myOpt.class_d
                        : $options._myOpt.class_early
                    " :dw="'830px'" :dt="'10vh'"></image-up>
                  <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
                </div>
                <!-- </el-input> -->
              </el-form-item>
              <el-form-item label="培训费用" prop="cost" class>
                <el-input v-model.trim="formData.cost" class="input-w260" placeholder="请填写培训费用"></el-input>
                <span class="cost-text">单位：元</span>
              </el-form-item>
              <el-form-item label="是否统一安排住宿" class="flex-form-item">
                <el-switch v-model="formData.ifLodging"></el-switch>
                <el-form-item label="住宿地点" prop="lodgingPlace" label-width="110px" class>
                  <el-input v-model.trim="formData.lodgingPlace" :disabled="!formData.ifLodging" class="input-w200" placeholder="请填写住宿地点"></el-input>
                </el-form-item>
                <el-form-item label="费用" prop="lodgingPrice" label-width="80px" class>
                  <el-select v-model="formData.lodgingPrice" class="hide" :disabled="!formData.ifLodging"></el-select>
                  <select class="set-sel input-w200" v-model="formData.lodgingPrice" :disabled="!formData.ifLodging">
                    <!-- <option value="">请选择讲师</option> -->
                    <option v-for="item in lodgingSelList" :key="item.val" :value="item.val">
                      {{ item.text }}
                    </option>
                  </select>
                  <!-- <el-input
                    v-model="formData.lodgingPrice"
                    :disabled='!formData.ifLodging'
                    class="input-w200 "
                    placeholder="请填写费用"
                  ></el-input>-->
                </el-form-item>
              </el-form-item>
              <el-form-item label="是否统一安排就餐" class="flex-form-item">
                <el-switch v-model="formData.ifEat"></el-switch>
                <el-form-item label="就餐地点" prop="eatPlace" label-width="110px" class>
                  <el-input v-model.trim="formData.eatPlace" :disabled="!formData.ifEat" class="input-w200" placeholder="请填写就餐地点"></el-input>
                </el-form-item>
                <el-form-item label="餐费" prop="eatPrice" label-width="80px" class>
                  <el-select v-model="formData.eatPrice" class="hide" :disabled="!formData.ifEat"></el-select>
                  <select class="set-sel input-w200" v-model="formData.eatPrice" :disabled="!formData.ifEat">
                    <!-- <option value="">请选择讲师</option> -->
                    <option v-for="item in eatSelList" :key="item.val" :value="item.val">
                      {{ item.text }}
                    </option>
                  </select>
                  <!-- <el-input
                    v-model="formData.eatPrice"
                    :disabled='!formData.ifEat'
                    class="input-w200 "
                    placeholder="请填写餐费"
                  ></el-input>-->
                </el-form-item>
              </el-form-item>
              <el-form-item label="是否统一安排差旅" class="flex-form-item">
                <el-switch v-model="formData.ifTravel"></el-switch>
                <el-form-item label="旅费" prop="travelPrice" label-width="110px" class>
                  <el-select v-model="formData.travelPrice" class="hide" :disabled="!formData.ifTravel"></el-select>
                  <select class="set-sel input-w200" v-model="formData.travelPrice" :disabled="!formData.ifTravel">
                    <!-- <option value="">请选择讲师</option> -->
                    <option v-for="item in travelList" :key="item.val" :value="item.val">
                      {{ item.text }}
                    </option>
                  </select>
                  <!-- <el-input
                    v-model="formData.eatPrice"
                    :disabled='!formData.ifEat'
                    class="input-w200 "
                    placeholder="请填写餐费"
                  ></el-input>-->
                </el-form-item>
              </el-form-item>
              <el-form-item label="报到时间" required>
                <el-form-item prop="reportStart" class="date-form-item">
                  <el-date-picker :editable="false" :clearable="false" value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" :picker-options="reportStartOpt" v-model="formData.reportStart" placeholder="请选择开始日期" type="date" style="width: 100%"></el-date-picker>
                </el-form-item>
                <span class="date-form-text">—</span>
                <el-form-item prop="reportEnd" class="date-form-item">
                  <el-time-select v-model="formData.reportEnd" :editable="false" :clearable="false" :picker-options="{
                      start: '07:00',
                      step: '00:10',
                      end: '18:30',
                    }" placeholder="请选择开始时间" style="width: 100%"></el-time-select>
                  <!-- <el-date-picker
                    type="datetime"
                    :editable="false"
                    :clearable="false"
                    value-format="timestamp"
                    :picker-options="reportEndOpt"
                    placeholder="请选择结束时间"
                    v-model="formData.reportEnd"
                    style="width: 100%;"
                  ></el-date-picker>-->
                </el-form-item>
              </el-form-item>
              <el-form-item label="离会时间" required>
                <el-form-item prop="leaveDate" class="date-form-item">
                  <el-date-picker :editable="false" :clearable="false" value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" :picker-options="leaveDateOpt" :default-value="calendarShow" v-model="formData.leaveDate" placeholder="请选择离会日期" type="date" style="width: 100%"></el-date-picker>
                </el-form-item>
                <span class="date-form-text">—</span>
                <el-form-item prop="leaveTime" class="date-form-item">
                  <el-time-select v-model="formData.leaveTime" :editable="false" :clearable="false" :picker-options="{
                      start: '07:00',
                      step: '00:10',
                      end: '18:30',
                    }" placeholder="请选择离会时间" style="width: 100%"></el-time-select>
                </el-form-item>
              </el-form-item>
              <el-form-item label="报到地点" prop="reportAddress" class>
                <el-input v-model.trim="formData.reportAddress" class="input-w260" placeholder="请填写报到地点"></el-input>
              </el-form-item>
              <el-form-item label="训练场地" prop="trainAddress" class>
                <el-input v-model.trim="formData.trainAddress" class="input-w260" placeholder="请填写训练场地"></el-input>
                <span class="tips-1">注:实践课场地信息将印制在学员证书上,请确认信息无误并无错别字</span>
              </el-form-item>
              <el-form-item label="理论课场地" prop="courseAddress" class>
                <el-input v-model.trim="formData.courseAddress" class="input-w260" placeholder="请填写理论课场地"></el-input>
              </el-form-item>
              <el-form-item label="培训班协调员" prop="saveContact" class="test-inline">
                <el-button type="primary" @click="showContactDialog">添加培训班协调员
                </el-button>
                <span :class="['tip', testContact ? 'yes' : 'no']">{{
                  testContact ? "培训班协调员添加成功" : "培训班协调员未添加"
                }}</span>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn">
        <el-button type="primary" @click="startClass('Audit')">提交审核
        </el-button>
        <el-button @click="startClass('Edit')">暂时保存</el-button>
      </div>
    </div>
    <el-dialog @closed="excelDiaCloseHandle" :visible.sync="ifExcelDiaShow" :close-on-click-modal="false" top="13vh" width="500px" class="yi-dialog-root">
      <div class="slot-dialog-header" slot="title">
        <span class="title">批量录入</span>
      </div>
      <div class="excel-dia-content">
        <div class="excel-main">
          <!-- <p class="upload-tips"><span style="color:red">温馨提示：</span> 2020年起开设的培训班将使用支持非大陆学员报名的新模板，旧模板将无法使用。</p> -->
          <file-upload action="/api/organization/student_up_excel.json" :test_file="testFile" :val.sync="excelVal" ref="excelUpload"></file-upload>
          <p class="upload-tips">
            <span>请上传 excel 文件 或&nbsp;</span>
            <a :href="loadExcelUrl" download="">下载模板</a>
            <span>&nbsp;编辑后上传</span>
          </p>
        </div>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <div class="btn save" @click="saveExcelData">保存</div>
          <div class="btn cancel" @click="ifExcelDiaShow = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog @open="stuDiaOpenHandle" :visible.sync="ifStuDiaShow" :close-on-click-modal="false" top="13vh" width="1024px" class="yi-dialog-root scroll-dialog">
      <div class="slot-dialog-header" slot="title">
        <span class="title">录入学员名单</span>
        <span class="prompt">注：学员手机号将作为登录培训系统的初始密码~</span>
      </div>
      <div class="dialog-content">
        <vue-scroll :ops="disScrollOpt" ref="stuVs">
          <div class="dia-scroll-content">
            <el-form :model="stusData" ref="stusDialogForm" label-width="66px" size="medium" class="dia-form">
              <div class="form-oneline-wrap clearfix" v-for="(stu, index) in stusData.stusInfoList" :key="stu.id">
                <span class="num">{{ index + 1 }}</span>
                <el-form-item label="姓名" label-width="77px" :prop="'stusInfoList.' + index + '.name'" :rules="{
                    required: true,
                    validator: (rule, value, callback) => {
                      validateName(rule, value, callback, true, index);
                    },
                    trigger: 'blur',
                  }" class="dia-input-wrap stu-name-wrap">
                  <el-input placeholder="请输入姓名" v-model="stu.name" class="dia-input-w160 name-input"></el-input>
                </el-form-item>
                <el-form-item label="手机号" :prop="'stusInfoList.' + index + '.phone'" :rules="{
                    required: true,
                    validator: (rule, value, callback) => {
                      validatePhone(rule, value, callback, true, index);
                    },
                    trigger: 'blur',
                  }" class="dia-input-wrap stu-phone-wrap">
                  <el-input placeholder="请输入手机号" v-model="stu.phone" class="dia-input-w160 phone-input"></el-input>
                </el-form-item>
                <el-form-item label="证件类型" label-width="78px" :prop="'stusInfoList.' + index + '.id_type'" :rules="{
                    required: true,
                    message: '请选择证件类型',
                    trigger: 'change',
                  }" class="dia-input-wrap stu-type-wrap">
                  <el-select v-model="stu.id_type" style="width: 200px">
                    <el-option v-for="item in id_types" :key="item.key" :label="item.key" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item ref="s" label="证件号" :prop="'stusInfoList.' + index + '.id_num'" :rules="{
                    required: true,
                    validator: (rule, value, callback) => {
                      validateNumberId(rule, value, callback, true, index);
                    },
                    trigger: 'blur',
                  }" class="dia-input-wrap stu-phone-wrap">
                  <el-input placeholder="请输入证件号" v-model.trim="stu.id_num" class="dia-input-w180 number-input"></el-input>
                </el-form-item>
                <div class="stu-opt">
                  <i :class="{
                      'el-icon-circle-plus': true,
                      'opt-icon': true,
                      add: stusData.stusInfoList.length < maxStus,
                      disabled: stusData.stusInfoList.length >= maxStus,
                    }" @click="addStus(index)" v-if="index === stusData.stusInfoList.length - 1"></i>
                  <i :class="{
                      'el-icon-remove': true,
                      'opt-icon': true,
                      remove: stusData.stusInfoList.length > 1,
                      disabled: stusData.stusInfoList.length <= 1,
                    }" @click="removeStus(index)"></i>
                </div>
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <!--<el-button type="primary" @click="saveStuList">保存</el-button>-->
        <!--<el-button type="info" @click="stuDiaEsc">取消</el-button>-->
        <div class="btns">
          <div class="btn save" @click="saveStuList">保存</div>
          <div class="btn cancel" @click="stuDiaEsc">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog @open="contactDiaOpen" :visible.sync="ifContactDiaShow" :close-on-click-modal="false" top="13vh" width="855px" class="yi-dialog-root scroll-dialog">
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加培训班协调员</span>
        <!-- <span class="prompt">注：学员手机号将作为登录培训系统的初始密码~</span> -->
      </div>
      <div class="dialog-content contact-dia-content">
        <vue-scroll :ops="disScrollOpt">
          <div class="dia-scroll-content">
            <el-form :model="contactData" ref="contactDialogForm" label-width="80px" size="medium" class="dia-form">
              <div class="form-oneline-wrap clearfix" v-for="(contact, index) in contactData.contactInfoList" :key="contact.id">
                <el-form-item label="姓名" :prop="'contactInfoList.' + index + '.name'" :rules="{
                    required: true,
                    message: `不能为空`,
                    trigger: `blur`,
                  }" class="dia-input-wrap contact-name-wrap">
                  <el-input placeholder="请输入联系人姓名" v-model="contact.name" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item label="电话" :prop="'contactInfoList.' + index + '.phone'" :rules="{
                    required: true,
                    validator: (rule, value, callback) => {
                      validatePhone(rule, value, callback, false);
                    },
                    trigger: `blur`,
                  }" class="dia-input-wrap contact-phone-wrap">
                  <el-input placeholder="请输入联系人手机号" v-model="contact.phone" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" :prop="'contactInfoList.' + index + '.email'" :rules="{
                    required: false,
                    validator: (rule, value, callback) => {
                      validateEmail(rule, value, callback, false);
                    },
                    trigger: `blur`,
                  }" class="dia-input-wrap contact-email-wrap">
                  <el-input placeholder="请输入联系人邮箱" v-model="contact.email" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item label="工作单位" :prop="'contactInfoList.' + index + '.work'" :rules="{
                    required: false,
                    validator: (rule, value, callback) => {
                      validateStrLength(rule, value, callback, false);
                    },
                    trigger: `blur`,
                  }" class="dia-input-wrap contact-email-wrap">
                  <el-input placeholder="请填写工作单位" v-model="contact.work" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-button class="form-oneline-btn" size="medium" type="danger" v-if="index > 0" @click="delContact(contact)">删除
                </el-button>
                <el-button v-else class="form-oneline-btn" size="medium" type="primary" @click="addContact">添加
                </el-button>
              </div>
            </el-form>
            <div class="dia-center-btn">
              <!-- <el-button class="dia-add-btn" type="primary" @click="addContact">添加</el-button> -->
            </div>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <!--<el-button type="primary" @click="saveContactList">保存</el-button>-->
        <!--<el-button type="info" @click="contactDiaEsc">取消</el-button>-->
        <div class="btns">
          <div class="btn save" @click="saveContactList">保存</div>
          <div class="btn cancel" @click="contactDiaEsc">取消</div>
        </div>
      </div>
    </el-dialog>
    <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag" :tips="tipMsg" :loading="loading" @hideTips="hideTipsDialog"></yioks-tips>
    <yioks-tips :showTips="levelFlag" :tips="levelMsg" @hideTips="hideLevelTips"></yioks-tips>
  </div>
</template>
<script>
  import TrainClassMixin from "@/minix/TrainClass";
  import {
    createTrainClass,
    testClassData,
    classDefaultLinks,
    class_train_periods,
  } from "@/api/agency/agency";
  import {operationMsgSave} from "@/api/common/api";
  import {correctStatus} from "@/assets/js/apiStatus";
  import {levelName, id_types} from "@/assets/js/select";
  import {mapGetters, mapActions} from "vuex";
  import commonFun from "@/assets/js/yioks";
  import fiveMixins from "@/minix/fiveMixins";
  import TrainClassFive from "@/minix/TrainClassFive";
  import {
    getFiveClassApplicationData,
  } from "@/api/agency/agency";
  const {
    mobile_phone,
    idCard_number,
    email,
    checkWork,
    checkHkongMacao,
    checkTaiwOld,
    checkPassport,
    checkHMT,
  } = commonFun;
  
//  const minStus = 18;
//  const maxStus = 24;
  const TRUE_FLAG = "Y",
    FALSE_FLAG = "N",
    SPLIT_CHAR = ",";
  
  const testType = (value) =>
    Object.prototype.toString.call(value).slice(8, -1).toLocaleLowerCase();
  
  export default {
    name:"CreateClass",
    mixins:[TrainClassMixin, fiveMixins, TrainClassFive],
    data(){
      const validatePhone = (rule, value, callback, bool, index) => {
        if(mobile_phone(value)){
          // 还需要显示后台的校验错误信息
          if(bool){
            // 如果后台校验手机号有问题
            if(this.dataTestResults[index].phone.bool){
              // console.log("后台校验手机");
              callback(new Error(this.dataTestResults[index].phone.msg));
            }else{
              callback();
            }
          }else{
            callback();
          }
        }else{
          callback(new Error("请输入有效的11位手机号"));
        }
      };
      const validateEmail = (rule, value, callback, bool, index) => {
        if(value == ""){
          callback();
        }
        if(email(value)){
          if(bool){
            // 如果后台校验手机号有问题
            if(dataTestResults[index].email.bool){
              // console.log("后台校验手机");
              callback(new Error(dataTestResults[index].email.msg));
            }else{
              callback();
            }
          }else{
            callback();
          }
        }else{
          callback(new Error("请输入格式正确的邮箱"));
        }
      };
      const validateStrLength = (rule, value, callback, bool, index) => {
        if(value == ""){
          callback();
        }else{
          const strLen = String(value).length;
          if(strLen > 20){
            callback(new Error("输入工作单位长度不应超过20"));
          }else{
            callback();
          }
        }
        //  else {
        //   callback(new Error("请输入格式正确的邮箱"));
        // }
      };
      const validateNumberId = (rule, value, callback, bool, index) => {
        let id_type = this.stusData.stusInfoList[index].id_type;
        let rules;
        if(id_type === "id_number"){
          rules = idCard_number;
        }else if(id_type === "idTypeCode_wgjzz"){
          rules = checkWork;
        }else if(id_type === "passport"){
          rules = checkPassport;
        }else if(id_type === "TAI"){
          rules = checkTaiwOld;
        }else if(id_type === "HM"){
          rules = checkHkongMacao;
        }else if(id_type === "idTypeCode_HMT"){
          rules = checkHMT;
        }
        
        // console.log(value, index);
        if(rules(value)){
          if(bool){
            if(this.dataTestResults[index].id_num.bool){
              callback(new Error(this.dataTestResults[index].id_num.msg));
            }else{
              callback();
            }
          }else{
            callback();
          }
        }else{
          callback(new Error("请输入有效证件号"));
        }
      };
      const validateName = (rule, value, callback, bool, index) => {
        if(value === ""){
          callback(new Error("请输入姓名"));
        }else{
          if(bool){
            if(this.dataTestResults[index].name.bool){
              callback(new Error(this.dataTestResults[index].name.msg));
            }else{
              callback();
            }
          }else{
            callback();
          }
        }
      };
      const level = this.$route.params.level;
      const minStus =(level === "L1") ? 15 : 18;
      const maxStus =(level === "L1") ? 20 : 24;
      const stusInfoList = Array(maxStus)
      .fill("")
      .map((item, idx) => {
        return {
          name:"",
          phone:"",
          id_num:"",
          id:idx + 1,
          id_type:"id_number",
        };
      });
      const dataTestResults = Array(maxStus)
      .fill(null)
      .map(() => ({
        phone:{bool:false, msg:""},
        id_num:{bool:false, msg:""},
        name:{bool:false, msg:""},
      }));
      return {
        minStus,
        maxStus,
        id_types,
        validatePhone,
        validateEmail,
        validateStrLength,
        validateNumberId,
        validateName,
        // 表示是否是由批量录入弹窗中的保存按钮调起的录入名单弹窗
        excelDiaLetStusDiaOpen:false,
        stusData:{
          stusInfoList:[...stusInfoList],
        },
        contactData:{
          contactInfoList:[{name:"", phone:"", email:"", work:"", id:1}],
        },
        ifStuDiaShow:false,
        ifContactDiaShow:false,
        ifExcelDiaShow:false,
        optionalAssistantLec:[],
        provinceList:[],
        cityList:[],
        countyList:[],
        lecturerList:[], // 讲师
        lecturerStore:[], // 讲师备份
        assistantLecturerList:[], // 助理讲师
        assistantStore:[], // 助理讲师备份
        assistantIdx:-1,
        formData:{
          // ifLodging: level === 'C' ? true :false, // 是否统一安排住宿  如果是C级 默认是安排的
          ifLodging:false, // 是否统一安排住宿  如果是C级 默认是安排的
          // ifEat: level === 'C' ? true :false,
          ifEat:false,
          ifTravel:false,
          curriculum:"",
          application_id:"",
          group_mode:6,
          hostOrg:[
            {
              val:"",
              key:Date.now(),
              placeholder:"请填写主办机构",
            },
          ],
          underOrg:[
            {
              val:"",
              key:Date.now(),
              placeholder:"请填写承办机构",
            },
          ],
          assistOrg:[
            {
              val:"",
              key:Date.now(),
              placeholder:"请填写协办机构",
            },
          ],
          class_level:level,
          className:levelName[level],
          trainStart:"",
          trainEnd:"",
          reportStart:"",
          reportEnd:"",
          leaveDate:"",
          leaveTime:"",
          classAddress:{
            province:"",
            city:"",
            county:"",
          },
          period:1,
          lecturer:"",
          assistantLecturer:[
            {
              val:"",
              key:Date.now(),
              placeholder:"(空)",
              isTestErr:null,
              errMsg:"",
            },
          ],
          fieldworkLecturer:[
            {
              val:"",
              key:Date.now(),
              placeholder:"如有实习讲师，可在此输入",
            },
          ],
          cost:(level === "L1") ? "3400" : "2000",
          lodgingPlace:"",
          lodgingPrice:1,
          eatPlace:"",
          eatPrice:1,
          travelPrice:1,
          reportAddress:"",
          trainAddress:"",
          courseAddress:"",
          saveContact:[],
          saveStus:JSON.parse(JSON.stringify(stusInfoList)),
          is_special_train:0,
        },
        levelName,
        dataTestResults,
        stusErrLen:0,
      };
    },
    computed:{
      ...mapGetters(["getStoreOrgData"]),
      isCountyNeeded(){
        if(this.getStoreOrgData){
          const {org_level} = this.getStoreOrgData;
          return this.getStoreOrgData.org_level === "city" ? true : false;
        }else{
          return false;
        }
      },
    },
    watch:{
      getStoreOrgData:{
        handler(val){
          // console.log("默认信息", val);
          if(testType(val) === "object"){
            // 创建培训班 开班地区默认选中当前机构的省
            this.formData.classAddress.province = String(val.province_id);
            this.provinceChange();
            this.formData.hostOrg[0].val = "中国足协";
            this.formData.underOrg[0].val = val.name;
          }
        },
        immediate:true,
        deep:true,
      },
      "formData.trainStart":{
        handler:function(val){
          const start = new Date(val).getTime();
          const end = new Date(this.formData.trainEnd).getTime();
          // 就算结束时间为'',选择开始日期时候也将结束日期默认后推一周
          if((start || 0) > (end || 0)){
            if (this.formData.class_level === "early") {
              this.formData.trainEnd = Number(val) + 24 * 60 * 60 * 1000 * 3; // 为期4天
            }
            if(this.formData.class_level === "L1"){
              this.formData.trainEnd = Number(val) + 24 * 60 * 60 * 1000 * 5; // 为期6天
            }
            
          }
        },
      },
      "formData.trainEnd":{
        handler(val){
          // 离会时间和培训结束时间保持一致
          if(val){
            const date = new Date(val);
            /*this.formData.leaveDate = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());*/
            this.formData.leaveDate = this.$yioks.time(date, false);
          }else{
            this.formData.leaveDate = "";
          }
        },
      },
    },
    created(){
      this.copyData = JSON.parse(JSON.stringify(this.formData));
      this.getProvinceList();
      this.setData();
      
      //    console.warn(
      //      "待办事项：",
      //      "in mixins TrainClass.js _myOpt Object need five kind img"
      //    );
    },
    methods:{
      setData(){
        this.getLecturerList(); // 获取讲师列表
        this.getClassLinks();
        if(this.getStoreOrgData === null) this.actionStoreOrgData();
      },
      changeState(val){
        if(val){
          let params = {
            start_date:val,
            class_level:this.formData.class_level,
            class_train_type:"train",
          };
          class_train_periods(params).then(({data:{status, result}}) => {
            if(Number(status) === 0){
              this.$set(this.formData, "period", result.periods);
            }
          });
        }
      },
      backComfimDialog(bool, sure){
        this.backComfim = bool;
        if(sure){
          /*this.$router.push({
            name: "TrainingCourseManager"
          });*/
          this.$router.go(-1);
        }
      },
      // 获取默认联系人列表
      getClassLinks(){
        classDefaultLinks({
          class_the_quality:"futsal",
        })
        .then(({data}) => {
          console.warn("增加职位");
          if(data.status === correctStatus){
            const {
              result:{linkman},
            } = data;
            if(linkman.length > 0){
              this.contactData.contactInfoList = linkman.map(
                ({email, mobile_phone, name, work, tc_id}, i) => ({
                  name,
                  email,
                  phone:mobile_phone,
                  work,
                  id:i + 1,
                })
              );
              this.testContact = true;
            }else{
              this.testContact = false;
            }
            this.formData.saveContact = JSON.parse(
              JSON.stringify(this.contactData.contactInfoList)
            );
            // 有了默认联系人的话，将联系人的校验结果为true，反之为false
          }else{
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
      // 是否确定提交数据弹窗
      hideTipsDialog(bool, sure){
        if(sure){
          // 提交数据
          this.ajaxCreatClass({status:this.ajaxStatus}, bool);
        }else{
          this.tipsFlag = bool;
        }
      },
      // 显示后台校验24个学员名单的结果
      testStusInfo(idx, key, msg, i){
        const index = idx - 1;
        const curInfo = this.dataTestResults[index];
        this.dataTestResults.splice(index, 1, {
          ...curInfo,
          [key]:{bool:true, msg},
        });
        this.$nextTick(() => {
          // console.log('sss hhh')
          this.$refs["stusDialogForm"].validateField(
            "stusInfoList." + index + "." + key
          );
          if(this.stusErrLen - 1 === i){
            for(const item of this.dataTestResults){
              for(const key in item){
                if(item.hasOwnProperty(key)){
                  item[key].bool = false;
                  item[key].msg = "";
                }
              }
            }
          }
        });
      },
      // 显示后台校验助理讲师列表的结果
      testAss(id, msg){
        this.formData.assistantLecturer.forEach((item, index) => {
          if(String(item.val) === id){
            item.isTestErr = true;
            item.errMsg = msg;
            this.$refs["mainForm"].validateField(
              "assistantLecturer." + index + ".val"
            );
            item.isTestErr = false;
            item.errMsg = "";
          }
        });
      },
      // 创建培训班的请求
      async ajaxCreatClass(statusParam, bool){
        const formdata = this.formData;
        const regis_start_time = this.getTimeStemp(
          formdata.reportStart,
          formdata.reportEnd
        ); // 报到时间
        const departure_time = this.getTimeStemp(
          formdata.leaveDate,
          formdata.leaveTime
        ); // 离会时间
        const ajaxParams = {
          image_url:formdata.curriculum,
          sponsor:formdata.hostOrg.map((item) => item.val).join(SPLIT_CHAR),
          organizer:formdata.underOrg.map((item) => item.val).join(SPLIT_CHAR),
          co_organizer:formdata.assistOrg
          .map((item) => item.val)
          .join(SPLIT_CHAR),
          // name: formdata.className,
          class_level:formdata.class_level,
          province_id:formdata.classAddress.province,
          city_id:formdata.classAddress.city,
          county_id:formdata.classAddress.county,
          periods:formdata.period,
          start_date:formdata.trainStart,
          end_date:formdata.trainEnd,
          teacher_ids:formdata.assistantLecturer
          .map((item) => item.val)
          .join(SPLIT_CHAR),
          teacher_off_id:formdata.lecturer.toString(),
          intern_teacher:formdata.fieldworkLecturer
          .map((item) => item.val)
          .join(SPLIT_CHAR),
          is_accommodation:formdata.ifLodging ? TRUE_FLAG : FALSE_FLAG,
          train_cost:formdata.cost,
          residence_address:formdata.lodgingPlace,
          accommodation_cost_type:
            formdata.lodgingPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          is_repast:formdata.ifEat ? TRUE_FLAG : FALSE_FLAG,
          repast_address:formdata.eatPlace,
          repast_cost_type:
            formdata.eatPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          is_travel:formdata.ifTravel ? TRUE_FLAG : FALSE_FLAG,
          travel_type:
            formdata.travelPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          regis_start_time,
          // regis_end_time: formdata.reportEnd,
          departure_time,
          regis_address:formdata.reportAddress,
          training_address:formdata.trainAddress,
          theory_address:formdata.courseAddress,
          group_mode:formdata.group_mode,
          application_id:formdata.application_id,
          class_linkman:JSON.stringify(
            formdata.saveContact.map((item) => ({
              name:item.name,
              phone:item.phone,
              email:item.email,
              work:item.work,
            }))
          ),
          student_list:JSON.stringify(
            formdata.saveStus.map(({name, phone, id_num, id, id_type}) => ({
              name,
              phone,
              id_num,
              id,
              id_type,
            }))
          ),
          is_special_train:formdata.is_special_train,
          ...statusParam,
          class_the_quality:"futsal",
        };
        this.loading = true;
        if(statusParam.status === "Audit"){
          ajaxParams.operation_type = "submit_class";
          await operationMsgSave(JSON.parse(JSON.stringify(ajaxParams))).then(
            ({data}) => {
              ajaxParams.operation_msg_id = data.result.operationMsg.msg_id;
            }
          );
        }
        // console.log('%c向小黑传的数据 ---> ', 'color:green;font-size: 20px;',ajaxParams)
        createTrainClass(JSON.parse(JSON.stringify(ajaxParams)))
        .then(({data}) => {
          this.loading = false;
          if(data.status === correctStatus){
            this.$router.go(-1);
          }else{
            this.$message.error(`${data.msg}`);
            if(Number(data.status) === 436 || Number(data.status) === 439){
              this.tipsFlag = bool;
              this.trainTimeAjaxErr = true;
              this.trainTimeAjaxErrMsg = data.msg;
              this.$refs["mainForm"].validateField("trainStart");
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
      },
      // 提交审核
      startClass(status){
        this.ajaxStatus = status;
        this.$refs["mainForm"].validate((valid) => {
          if(valid){
            const formdata = this.formData;
            
            testClassData({
              periods:formdata.period,
              status,
              teacher_off_id:formdata.lecturer,
              teacher_ids:formdata.assistantLecturer
              .map((item) => item.val)
              .join(SPLIT_CHAR),
              student_list:JSON.stringify(
                formdata.saveStus.map(
                  ({name, phone, id_num, id_type}, index) => ({
                    name,
                    phone,
                    id_num,
                    id:index + 1,
                    id_type,
                  })
                )
              ),
              start_date:formdata.trainStart,
              end_date:formdata.trainEnd,
              class_level:formdata.class_level,
              is_special_train:formdata.is_special_train,
              class_the_quality:"futsal",
            }).then(({data}) => {
              if(data.status === correctStatus){
                const {result} = data;
                switch(result.consequence.toLowerCase()){
                  // 显示是否确定弹窗
                  case "ok":
                    let stuTips = "";
                    let scoreTips = "";
                    if(result.stuHint){
                      const {stuHintList} = result;
                      stuTips =
                        "【" +
                        stuHintList.slice(0, 3) +
                        (stuHintList.length > 3
                          ? `等${stuHintList.length}人`
                          : "") +
                        "】曾经参加过此类培训，";
                    }
                    //                  if (result.coachHint) {
                    //                    const {coachHintList} = result;
                    //                    scoreTips = "【" + coachHintList.slice(0, 3) + (coachHintList.length > 3 ? `等${coachHintList.length}人` : '') + "】的成绩库成绩查询异常，";
                    //                  }
                    if(result.stuHint){
                      this.tipMsg = `学员名单中${stuTips}请确认是否继续提交？`;
                      this.tipsFlag = true;
                      break;
                    }
                    if(status === "Audit"){
                      this.tipMsg = "请确认是否继续提交？";
                    }else{
                      this.tipMsg = "请确认是否暂时保存？";
                    }
                    this.tipsFlag = true;
                    break;
                  // if (result.stuHint) {
                  //   const { stuHintList } = result;
                  //   this.tipMsg =
                  //     "学员名单中【" +
                  //     stuHintList.slice(0, 3) +
                  //     (stuHintList.length > 3
                  //       ? `等${stuHintList.length}人`
                  //       : "") +
                  //     "】曾经参加过此类培训，请确认是否继续提交？";
                  // }
                  // // this.tipMsg = "请确认是否提交审核？";
                  // if(status === 'Audit') {
                  //   this.tipMsg = "请确认是否继续提交？";
                  // }else{
                  //   this.tipMsg = "请确认是否暂时保存？";
                  // }
                  // this.tipsFlag = true;
                  // break;
                  
                  // 后台校验数据有误，显示后端校验
                  case "error":
                    this.$message.error(this.$options._myOpt.rearEndErrorMsg);
                    // 校验期数
                    if(result.periodsErr){
                      this.periodAjaxTestErr = true;
                      this.periodAjaxTestMsg = result.periodsErr;
                      this.$refs["mainForm"].validateField("period");
                    }
                    this.periodAjaxTestErr = false;
                    // 校验主讲师
                    if(result.teaOffError){
                      this.lecturerAjaxTestErr = true;
                      this.lecturerAjaxTestMsg = result.teaOffError;
                      this.$refs["mainForm"].validateField("lecturer");
                    }
                    this.lecturerAjaxTestErr = false;
                    // 校验学员列表
                    if(result.studentErr.length > 0){
                      this.stusErrLen = result.studentErr.length;
                      this.excelDiaLetStusDiaOpen = false;
                      // 校验学员名单
                      this.ifStuDiaShow = true;
                      this.$nextTick(() => {
                        for(const [
                          i,
                          {err, index_id},
                        ] of result.studentErr.entries()){
                          for(const key in err){
                            if(err.hasOwnProperty(key)){
                              this.testStusInfo(index_id, key, err[key], i);
                            }
                          }
                        }
                      });
                    }
                    // 校验助理讲师
                    if(result.teacherErr.length > 0){
                      for(const [
                        i,
                        {msg, id},
                      ] of result.teacherErr.entries()){
                        this.testAss(id, msg);
                      }
                    }
                    break;
                }
              }else{
                this.$message.error(data.msg);
              }
            });
          }else{
            this.$message.error("必填项不能为空");
          }
        });
      },
      goBack(){
        this.backComfim = true;
      },
      addStus(idx){
        if(this.stusData.stusInfoList.length >= this.maxStus) return false;
        this.stusData.stusInfoList.push({
          name:"",
          phone:"",
          id_num:"",
          id_type:"id_number",
        });
        this.$nextTick(() => {
          this.$refs["stuVs"].scrollTo({y:"100%"}, true);
        });
      },
      removeStus(idx){
        // console.log(this.$refs[`s`][idx])
        if(this.stusData.stusInfoList.length <= 1) return false;
        this.$refs[`s`][idx].clearValidate();
        setTimeout(() => {
          this.stusData.stusInfoList.splice(idx, 1);
        }, 20);
      },
      changeClassLevel(val){
        this.setStoreOrgData(null);
        let cost = this.level === 'L1' ? "3400" :"2000";
        // (this.level === "C") && (cost = "5000");
        // (this.level === "D") && (cost = "2500");
        this.formData = {
          ...JSON.parse(JSON.stringify(this.copyData)),
          class_level:this.level,
          className:this.levelName[this.level],
          cost,
        };
        this.setData();
        setTimeout(() => {
          this.citySelErr = false;
          this.testStus = false;
          this.$refs["mainForm"].clearValidate();
          this.$router.replace({
            name:this.$route.name,
            params:{
              ...this.$route.params,
              level:this.level,
            },
          });
        }, 0);
      },
      selectLevel(val){
        this.level = val;
        this.levelFlag = true;
      },
      hideLevelTips(bool, sure){
        this.levelFlag = bool;
        if(sure){
          this.changeClassLevel();
        }else{
          this.$set(this.formData, "class_level", this.$route.params.level);
        }
      },
      
      handleApplicationChange(val){
        if(val){
          const {nullToStr} = this.$yioks
          const aimData = this.select_application_list.filter((item) => {
            return item.application_id === val;
          }) || [];
          if(aimData.length){
            const defaultFormData = aimData[0]
            console.log('defaultFormData', defaultFormData);
            const {training_address, theory_address, class_end, class_start, teacher_off_id, teacher_ids,application_id} = aimData[0];
            const setData = {
              trainAddress:training_address,
              courseAddress:theory_address,
              lecturer:nullToStr(teacher_off_id)
                ? Number(teacher_off_id)
                : "",
              assistantLecturer:nullToStr(teacher_ids).split(SPLIT_CHAR).map((item, index) => {
                return {
                  val:item === '' ? '' : Number(item),
                  key:index,
                  isTestErr:null,
                  placeholder:"(空)",
                };
              }),
              trainStart:class_start,
              trainEnd:class_end,
            }
            this.formData = Object.assign({}, this.formData, setData)
            
          }
          this.setLinkmanData(val);
        }
      },
      
      setLinkmanData(application_id){
        console.log('获取协调员')
        getFiveClassApplicationData({
          application_id:application_id,
        })
        .then(({data}) => {
          if(data.status === correctStatus){
            const {
              result:{linkMan},
            } = data;
            if(linkMan.length > 0){
              this.contactData.contactInfoList = linkMan.map(
                ({email, mobile_phone, name, work, tc_id}, i) => ({
                  name,
                  email,
                  phone:mobile_phone,
                  work,
                  id:i + 1,
                })
              );
              this.testContact = true;
            }else{
              this.testContact = false;
            }
            this.formData.saveContact = JSON.parse(
              JSON.stringify(this.contactData.contactInfoList)
            );
            // 有了默认联系人的话，将联系人的校验结果为true，反之为false
          }else{
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
    },
  };
</script>

<style lang="stylus">
  @import '~@/assets/css/class'
  .tips-1
    margin-left 5px
    color $color_suc
    font-size 14px
</style>

